import React from 'react';
import RetireeView from "./RetireeView";
import {connect} from "react-redux";
import {Link, withRouter, NavLink} from "react-router-dom";

function Retiree(props) {
    return (
            <RetireeView {...props}/>
    )
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isMobileDevice: state.appState.deviceInfo.isMobileDevice,
    isLGView: state.appState.deviceInfo.isLGView,
    isXLView: state.appState.deviceInfo.isXLView,
    isXSView: state.appState.deviceInfo.isXSView,
});

export default connect(mapStateToProps, {})(withRouter(Retiree));
